/**
 * Public Explore posts hold only what the card needs. Keep this list in sync with
 * communityPostFields() in firestore.rules.
 */
export const COMMUNITY_POST_FIELDS = [
  'userId',
  'designId',
  'displayName',
  'mainImage',
  'title',
  'garmentType',
  'color',
  'likeCount',
  'createdAt',
  'updatedAt'
]

export const DEFAULT_COMMUNITY_NAME = 'Style AI designer'
export const SHARE_CONFIRM_MESSAGE = 'This design will be public on Explore'

export function communityPostId(uid, designId) {
  return `${uid}_${designId}`
}

function cleanText(value, max) {
  return typeof value === 'string' ? value.trim().slice(0, max) : ''
}

/** Only a name the customer typed into Settings; never their email or provider name. */
export function communityDisplayName(post) {
  return cleanText(post?.displayName, 60) || DEFAULT_COMMUNITY_NAME
}

export function buildCommunityPost(design, user, mainImage) {
  const specs = design?.specifications || {}
  const garmentType = cleanText(specs.type, 60)
  const color = cleanText(specs.color, 60)
  const displayName = cleanText(user?.communityName, 60)
  return {
    userId: user.uid,
    designId: String(design.id),
    mainImage,
    title: cleanText(design.title, 120) || `${garmentType || 'Custom'} design`,
    garmentType: garmentType || null,
    color: color || null,
    ...(displayName ? { displayName } : {})
  }
}

/** True for posts that belong to this design, including older posts keyed by design id. */
export function isPostForDesign(post, uid, designId) {
  if (!post || post.userId !== uid || !designId) return false
  const id = String(designId)
  return post.designId === id || post.id === id || post.id === communityPostId(uid, id)
}
